module.exports = __webpack_public_path__ + "img/game-background-blur.7479638b.svg";